'use strict';

exports.__esModule = true;

var _isGenerator = require('is-generator');

var _isGenerator2 = _interopRequireDefault(_isGenerator);

var _isPromise = require('is-promise');

var _isPromise2 = _interopRequireDefault(_isPromise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var handleGenerator = function handleGenerator(generator, dispatch) {
  var handle = function handle(_ref) {
    var value = _ref.value;
    var done = _ref.done;

    if (done) return Promise.resolve(value);

    var result = (0, _isPromise2.default)(value) ? value : dispatch(value);
    return Promise.resolve(result).then(function (res) {
      return handle(generator.next(res));
    }).catch(function (err) {
      return handle(generator.throw(err));
    });
  };

  try {
    return handle(generator.next());
  } catch (ex) {
    return Promise.reject(ex);
  }
};

var createGeneratorThunkMiddleware = function createGeneratorThunkMiddleware(extraArgument) {
  return function (_ref2) {
    var dispatch = _ref2.dispatch;
    var getState = _ref2.getState;
    return function (next) {
      return function (action) {
        if (_isGenerator2.default.fn(action)) {
          var generator = action(getState, extraArgument);
          return handleGenerator(generator, dispatch);
        }

        return next(action);
      };
    };
  };
};

var generatorThunk = createGeneratorThunkMiddleware();
generatorThunk.withExtraArgument = createGeneratorThunkMiddleware;

exports.default = generatorThunk;